/* eslint-disable
  jsx-a11y/anchor-is-valid,
  jsx-a11y/no-static-element-interactions,
  jsx-a11y/no-noninteractive-tabindex
*/
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { FallbackCallout } from './fallback-callout';
import { getLinkWithFallbackLinkStyles } from './styles/link-with-fallback-callout';

const DefaultLink = ({
  href,
  children,
  className,
  linkText,
  ariaLabel,
}) => (
  <a href={href} className={className} aria-label={ariaLabel}>
    {linkText || children}
  </a>
);

DefaultLink.propTypes = {
  children: PropTypes.node,
  linkText: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

DefaultLink.defaultProps = {
  href: null,
  className: null,
  children: null,
  linkText: null,
  ariaLabel: null,
};

const UnthemedLinkWithFallBack = ({
  children,
  classes,
  href,
  className,
  calloutTitle,
  calloutClassName,
  placement,
  siteMapId,
  ariaLabel,
}) => {
  const [showFallback, setShowFallback] = useState(false);
  const target = useRef();
  return (
    <React.Fragment>
      <a
        ref={target}
        tabIndex="0"
        aria-label={ariaLabel}
        className={className}
        onClick={() => setShowFallback(true)}
        onKeyDown={(e) => {
          if (e.keyCode === 13 /* enter key */) {
            setShowFallback(true);
          }
        }}
      >
        {children}
        <Glyphicon glyph="ba-OpenInNewWindow" className={classes.fallbackIcon} />
      </a>
      <FallbackCallout
        title={calloutTitle || children}
        getOldUIPathOverride={href}
        show={showFallback}
        classes={calloutClassName}
        handleClose={() => setShowFallback(false)}
        placement={placement}
        siteMapId={siteMapId}
        target={target.current}
      />
    </React.Fragment>);
};

UnthemedLinkWithFallBack.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    fallbackIcon: PropTypes.string.isRequired,
  }).isRequired,
  href: PropTypes.string,
  calloutTitle: PropTypes.string,
  calloutClassName: PropTypes.string,
  placement: PropTypes.string,
  siteMapId: PropTypes.string,
  ariaLabel: PropTypes.string,
};

UnthemedLinkWithFallBack.defaultProps = {
  href: null,
  className: null,
  calloutTitle: null,
  calloutClassName: null,
  placement: 'left',
  siteMapId: null,
  ariaLabel: null,
};

export const ThemedLinkWithFallBack =
  withDefaultStyles(UnthemedLinkWithFallBack, getLinkWithFallbackLinkStyles);

export const LinkWithFallBack = ({ isFallback, ...rest }) =>
  (isFallback ? <ThemedLinkWithFallBack {...rest} /> : <DefaultLink {...rest} />);

LinkWithFallBack.propTypes = {
  isFallback: PropTypes.bool,
};

LinkWithFallBack.defaultProps = {
  isFallback: false,
};
